import palette from '../../palette';

export default {
  root: {
    color: palette.black,
    fontSize: "14px",
    textTransform: "uppercase",
    marginBottom: "6px",
    display: "block",
    ['@media (max-width: 768px)']: {
      color: palette.grayText,
      fontSize: "10px",
    },
  },
};